export default class StudentAbsentCriteria {
  constructor({
    localtrainingId,
    modalityId,
    categoryId,
    teacherId,
    dateStart,
    dateEnd,
    absentNumber,
  } = {}) {
    this.localtrainingId = localtrainingId
    this.modalityId = modalityId
    this.categoryId = categoryId
    this.teacherId = teacherId
    this.dateStart = dateStart
    this.dateEnd = dateEnd
    this.absentNumber = absentNumber
  }
}